import { __assign } from "tslib";
import React from "react";
import PropTypes from "prop-types";
import styles from "./PnmacPaper.styles.js";
import { View, TouchableOpacity } from "react-native";
var PnmacPaper = /*#__PURE__*/React.forwardRef(function PnmacPaper(props, ref) {
  return /*#__PURE__*/React.createElement(TouchableOpacity, {
    activate: props.activate,
    disabled: props.disabled,
    onPress: props.onPress
  }, /*#__PURE__*/React.createElement(View, __assign({
    style: props.containerStyles ? props.containerStyles : styles.containerStyles,
    ref: ref
  }, props, {
    testID: "paper",
    nativeID: props.idTag1
  })));
});
PnmacPaper.defaultProps = {
  activate: false
};
PnmacPaper.propTypes = {
  children: PropTypes.node,
  containerStyles: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]),
  onPress: PropTypes.func,
  activate: PropTypes.bool
};
export default PnmacPaper;